/**
 * Theme Requirements Aggregation for Repli Sandbox Avenue
 * 
 * Extends the base avenue theme requirements with Repli Sandbox Avenue specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-avenue/requirements';

/**
 * Repli Sandbox Avenue component requirement overrides.
 * Add requirements for any override components here.
 */
const replisandboxavenueOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Repli Sandbox Avenue theme.
 * Inherits from avenue theme and overrides with Repli Sandbox Avenue components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...replisandboxavenueOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
